import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  CardContent,
  Typography,
  IconButton,
  TextField,
  Button,
  styled,
  FormControl,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import axios from "axios";
import { API_BASE_URL } from "../../../apiConfig";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import LinkIcon from "@mui/icons-material/Link";
import ArticleEditor from "../manageStores/ArticleEditor";
import { refreshTokenIfNeeded } from "../refreshTokenIfNeeded";
import { useNavigate } from "react-router-dom";

const StyledCard = styled(Box)(({ theme }) => ({
  // تصميم خاص
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  height: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

function EditSignModal({ storeId, onClose, onSubmit }) {
  const [isLoading, setIsLoading] = useState(false);
  const [adsData, setAdsData] = useState({
    slug: "",
    imageURL: "",
  });
  const navigate = useNavigate();

  const [imageFile, setImageFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    const fetchCarData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}Ads/Find/${storeId}`);
        setAdsData(response.data);
        setAdsData({
          slug: response.data.slug || "",
          imageURL: response.data.imageURL || "",
        });
        setImageFile(response.data.imageURL);
        setPreviewImage(response.data.imageURL);
      } catch (error) {
        alert("Failed to load ads data.");
      }
    };

    fetchCarData();
  }, [storeId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdsData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => {
        setAdsData((prevData) => ({
          ...prevData,
          imageURL: reader.result,
        }));
      };
      reader.readAsDataURL(file);
      setImageFile(file);
    } else {
      console.error("الملف غير صالح");
    }
    e.target.value = "";
  };

  const handleRemoveImage = () => {
    setAdsData((prevData) => ({
      ...prevData,
      imageURL: "",
    }));
    setImageFile(null);
  };

  const handleSubmit = async () => {
    if (!imageFile) {
      alert("يرجى ملء جميع الحقول.");
      return;
    }

    const token = localStorage.getItem("token");

    setIsLoading(true);

    const formData = new FormData();
    formData.append("slug", adsData.slug?.trim() || "");
    formData.append("imageURL", adsData.imageURL);

    if (imageFile) {
      formData.append("imageFile", imageFile);
    } else {
      formData.append("imageFile", previewImage);
    }

    try {
      await axios.put(`${API_BASE_URL}Ads/Update/${storeId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      alert("تم تعديل الإعلان بنجاح");
      onSubmit();
      onClose();
    } catch (error) {
      if (error.response?.status === 401) {
        try {
          const newToken = await refreshTokenIfNeeded();

          if (!newToken) {
            return navigate("/", { replace: true });
          }

          // إعادة الطلب بالتوكن الجديد
          await axios.put(`${API_BASE_URL}Ads/Update/${storeId}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${newToken}`,
            },
          });

          alert("تم تعديل الإعلان بنجاح");
          onSubmit();
          onClose();
        } catch (retryError) {
          alert("Retry failed: " + retryError.message);
        }
      } else {
        alert(
          "Error updating store: " + (error.response?.data || error.message),
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <div>..جاري التحميل</div>;
  }

  return (
    <Modal
      dir="rtl"
      open={true}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <StyledCard>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                fontFamily: "'Changa', sans-serif",
              }}
            >
              <h3>تعديل إعلان</h3>
            </div>
          </Box>
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", top: 16, right: 16 }}
          >
            <CloseIcon />
          </IconButton>

          {/* تصميم العرض الجانبي للصورة والحقول */}
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            {/* الصورة على اليسار */}
            <Box
              sx={{
                width: "40%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* عرض الصورة أو النص الافتراضي */}
              <Box
                sx={{
                  width: 300,
                  height: 180,
                  marginTop: 2,
                  border: "1px solid #ccc",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#f5f5f5",
                  textAlign: "center",
                  borderRadius: 2,
                }}
              >
                {adsData.imageURL ? (
                  <img
                    src={adsData.imageURL}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <Typography variant="body2">لا توجد صورة</Typography>
                )}
              </Box>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "3%",
                  gap: "10px",
                }}
              >
                <Button variant="contained" component="label">
                  تحميل صورة
                  <input type="file" hidden onChange={handleFileChange} />
                </Button>

                {/* زر إزالة الصورة */}
                {adsData.imageURL && (
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleRemoveImage} // استدعاء دالة إزالة الصورة هنا
                    //sx={{ mt: 2 }}
                  >
                    إزالة الصورة
                  </Button>
                )}
              </div>
            </Box>

            {/* الحقول على اليمين */}
            <Box sx={{ width: "65%" }}>
              <CardContent sx={{ textAlign: "right", mt: 1 }}>
                {/* حقول الإدخال */}

                <FormControl fullWidth sx={{ marginBottom: 1 }}>
                  <TextField
                    placeholder="ضع اسم رابط المتجر (اتركة فارغ اذا لم ترغب توجية الزوار الى المتجر)"
                    value={adsData.slug}
                    //disabled
                    name="slug"
                    onChange={handleChange}
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LinkIcon sx={{ color: "#1976d2" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </CardContent>
            </Box>
          </Box>

          <Box sx={{ textAlign: "center", mt: 2 }}>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              حفظ التعديلات
            </Button>
          </Box>
        </StyledCard>
      </Box>
    </Modal>
  );
}
export default EditSignModal;
